import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.reduce.js";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, vModelText as _vModelText, withDirectives as _withDirectives, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle, Teleport as _Teleport, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "flex w-80 flex-shrink-0 flex-col border-r border-slate-200 bg-white"
};
const _hoisted_2 = {
  class: "border-b border-slate-100 p-4"
};
const _hoisted_3 = {
  class: "filter-bar-field-sm relative"
};
const _hoisted_4 = {
  class: "flex w-full items-center justify-between gap-3"
};
const _hoisted_5 = {
  class: "flex items-center gap-1 border-b border-slate-100 p-2 px-4"
};
const _hoisted_6 = ["onClick"];
const _hoisted_7 = {
  key: 0,
  class: "ml-1 rounded-full bg-red-500 px-1.5 py-0.5 text-xs leading-none text-white"
};
const _hoisted_8 = {
  class: "flex-1 overflow-y-auto"
};
const _hoisted_9 = {
  key: 0,
  class: "space-y-3 p-4"
};
const _hoisted_10 = {
  key: 1,
  class: "p-8 text-center"
};
const _hoisted_11 = {
  key: 2
};
const _hoisted_12 = ["onClick", "onContextmenu"];
const _hoisted_13 = {
  class: "relative flex-shrink-0"
};
const _hoisted_14 = ["src"];
const _hoisted_15 = {
  key: 2,
  class: "flex h-10 w-10 items-center justify-center rounded-full bg-violet-500"
};
const _hoisted_16 = {
  key: 3,
  class: "absolute -bottom-0.5 -right-0.5 h-3 w-3 rounded-full border-2 border-white bg-green-400"
};
const _hoisted_17 = {
  class: "min-w-0 flex-1"
};
const _hoisted_18 = {
  class: "mb-0.5 flex items-center justify-between"
};
const _hoisted_19 = {
  class: "flex min-w-0 items-center gap-1.5"
};
const _hoisted_20 = {
  class: "truncate text-sm font-medium text-slate-800"
};
const _hoisted_21 = {
  key: 0,
  class: "h-3 w-3 flex-shrink-0 text-amber-500",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_22 = {
  key: 1,
  class: "h-3 w-3 flex-shrink-0 text-slate-400",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_23 = {
  key: 2,
  class: "flex-shrink-0 rounded bg-primary-100 px-1 py-0.5 text-[10px] leading-none text-primary-600"
};
const _hoisted_24 = {
  key: 3,
  class: "flex-shrink-0 rounded bg-emerald-100 px-1 py-0.5 text-[10px] leading-none text-emerald-600"
};
const _hoisted_25 = {
  class: "ml-2 flex-shrink-0 text-[11px] text-slate-400"
};
const _hoisted_26 = {
  class: "flex items-center justify-between"
};
const _hoisted_27 = {
  class: "truncate text-xs text-slate-500"
};
import { ref, computed } from 'vue';
import { ElMessage } from 'element-plus';
import CompactFilterBar from '@/components/CompactFilterBar.vue';
import { useChatStore } from '@/stores/chat';
import { useUserStore } from '@/stores/user';
export default {
  __name: 'ConversationList',
  setup(__props) {
    const chatStore = useChatStore();
    const userStore = useUserStore();
    const currentUserId = computed(() => userStore.userInfo?.userId);
    function getConvAvatar(conv) {
      if (conv.type === 'group') return '';
      const other = (conv.members || []).find(m => String(m.id) !== String(currentUserId.value));
      if (other) return chatStore.getUserInfo(other.id).avatar;
      return '';
    }
    const showConvMenu = ref(false);
    const convMenuPos = ref({
      x: 0,
      y: 0
    });
    const activeConv = ref(null);
    function openConvMenu(e, conv) {
      activeConv.value = conv;
      convMenuPos.value = {
        x: e.clientX,
        y: e.clientY
      };
      showConvMenu.value = true;
    }
    function handlePin() {
      if (activeConv.value) {
        chatStore.pinConversation(activeConv.value.id);
        ElMessage.success(chatStore.isConversationPinned(activeConv.value.id) ? '已置顶' : '已取消置顶');
      }
      showConvMenu.value = false;
    }
    function handleMute() {
      if (activeConv.value) {
        chatStore.muteConversation(activeConv.value.id);
        ElMessage.success(chatStore.isConversationMuted(activeConv.value.id) ? '已开启免打扰' : '已关闭免打扰');
      }
      showConvMenu.value = false;
    }
    function handleDeleteConv() {
      if (activeConv.value) {
        chatStore.deleteConversation(activeConv.value.id);
        ElMessage.success('会话已删除');
      }
      showConvMenu.value = false;
    }
    const tabs = computed(() => {
      const countByType = type => chatStore.conversations.filter(c => c.type === type).reduce((sum, c) => sum + (c.unreadCount || 0), 0);
      return [{
        value: 'all',
        label: '全部',
        count: chatStore.totalUnreadCount
      }, {
        value: 'internal',
        label: '内部',
        count: countByType('internal')
      }, {
        value: 'customer',
        label: '客户',
        count: countByType('customer')
      }, {
        value: 'group',
        label: '群聊',
        count: countByType('group')
      }];
    });
    function formatTime(timeStr) {
      if (!timeStr) return '';
      const date = new Date(timeStr);
      if (Number.isNaN(date.getTime())) return '';
      const now = new Date();
      const isToday = date.toDateString() === now.toDateString();
      if (isToday) return date.toLocaleTimeString('zh-CN', {
        hour: '2-digit',
        minute: '2-digit',
        hour12: false
      });
      const yesterday = new Date(now);
      yesterday.setDate(yesterday.getDate() - 1);
      if (date.toDateString() === yesterday.toDateString()) return '昨天';
      return date.toLocaleDateString('zh-CN', {
        month: '2-digit',
        day: '2-digit'
      });
    }
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(CompactFilterBar, {
        "shell-class": "mb-0 rounded-xl border border-slate-200 bg-slate-50/70",
        "body-class": "p-3"
      }, {
        actions: _withCtx(() => [_createElementVNode("div", _hoisted_4, [_cache[6] || (_cache[6] = _createElementVNode("h2", {
          class: "text-lg font-semibold text-slate-800"
        }, "消息", -1)), _createElementVNode("button", {
          class: "cursor-pointer rounded-lg p-1.5 text-slate-400 transition-colors hover:bg-primary-50 hover:text-primary-500",
          title: "新建会话",
          onClick: _cache[1] || (_cache[1] = $event => _unref(chatStore).showNewConversationDialog = true)
        }, [...(_cache[5] || (_cache[5] = [_createElementVNode("svg", {
          class: "w-5 h-5",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24"
        }, [_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M12 4v16m8-8H4"
        })], -1)]))])])]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_3, [_cache[4] || (_cache[4] = _createElementVNode("svg", {
          class: "absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-slate-400",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24"
        }, [_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
        })], -1)), _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _unref(chatStore).searchKeyword = $event),
          type: "text",
          placeholder: "搜索联系人或消息...",
          class: "form-search-input form-control-sm w-full"
        }, null, 512), [[_vModelText, _unref(chatStore).searchKeyword]])])]),
        _: 1
      })]), _createElementVNode("div", _hoisted_5, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tabs.value, tab => {
        return _openBlock(), _createElementBlock("button", {
          key: tab.value,
          class: _normalizeClass(["cursor-pointer rounded-md px-3 py-1.5 text-xs font-medium transition-colors", _unref(chatStore).filterTab === tab.value ? 'bg-primary-50 text-primary-700' : 'text-slate-500 hover:bg-slate-50 hover:text-slate-700']),
          onClick: $event => _unref(chatStore).filterTab = tab.value
        }, [_createTextVNode(_toDisplayString(tab.label) + " ", 1), tab.count > 0 ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(tab.count > 99 ? '99+' : tab.count), 1)) : _createCommentVNode("", true)], 10, _hoisted_6);
      }), 128))]), _createElementVNode("div", _hoisted_8, [_unref(chatStore).loading ? (_openBlock(), _createElementBlock("div", _hoisted_9, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, i => {
        return _createElementVNode("div", {
          key: i,
          class: "flex animate-pulse items-center gap-3"
        }, [...(_cache[7] || (_cache[7] = [_createElementVNode("div", {
          class: "h-10 w-10 flex-shrink-0 rounded-full bg-slate-200"
        }, null, -1), _createElementVNode("div", {
          class: "flex-1"
        }, [_createElementVNode("div", {
          class: "mb-2 h-4 w-24 rounded bg-slate-200"
        }), _createElementVNode("div", {
          class: "h-3 w-36 rounded bg-slate-100"
        })], -1)]))]);
      }), 64))])) : _unref(chatStore).filteredConversations.length === 0 ? (_openBlock(), _createElementBlock("div", _hoisted_10, [...(_cache[8] || (_cache[8] = [_createElementVNode("svg", {
        class: "mx-auto mb-2 h-12 w-12 text-slate-300",
        fill: "none",
        stroke: "currentColor",
        viewBox: "0 0 24 24"
      }, [_createElementVNode("path", {
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": "1.5",
        d: "M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z"
      })], -1), _createElementVNode("p", {
        class: "empty-state-title"
      }, "暂无会话", -1)]))])) : (_openBlock(), _createElementBlock("div", _hoisted_11, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(chatStore).filteredConversations, conv => {
        return _openBlock(), _createElementBlock("div", {
          key: conv.id,
          class: _normalizeClass(["group/conv relative flex cursor-pointer items-center gap-3 border-l-2 px-4 py-3 transition-colors", [_unref(chatStore).currentConversationId === conv.id ? 'border-l-primary-500 bg-primary-50/70' : 'border-l-transparent hover:bg-slate-50', _unref(chatStore).isConversationPinned(conv.id) ? 'bg-amber-50/40' : '']]),
          onClick: $event => _unref(chatStore).selectConversation(conv.id),
          onContextmenu: _withModifiers($event => openConvMenu($event, conv), ["prevent"])
        }, [_createElementVNode("div", _hoisted_13, [conv.type !== 'group' && getConvAvatar(conv) ? (_openBlock(), _createElementBlock("img", {
          key: 0,
          src: getConvAvatar(conv),
          class: "h-10 w-10 rounded-full object-cover"
        }, null, 8, _hoisted_14)) : conv.type !== 'group' ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: _normalizeClass(["flex h-10 w-10 items-center justify-center rounded-full text-sm font-medium text-white", conv.type === 'internal' ? 'bg-primary-500' : 'bg-emerald-500'])
        }, _toDisplayString(conv.name.slice(-2)), 3)) : (_openBlock(), _createElementBlock("div", _hoisted_15, [...(_cache[9] || (_cache[9] = [_createElementVNode("svg", {
          class: "h-5 w-5 text-white",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24"
        }, [_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"
        })], -1)]))])), conv.type !== 'group' && conv.online ? (_openBlock(), _createElementBlock("span", _hoisted_16)) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_17, [_createElementVNode("div", _hoisted_18, [_createElementVNode("div", _hoisted_19, [_createElementVNode("span", _hoisted_20, _toDisplayString(conv.name), 1), _unref(chatStore).isConversationPinned(conv.id) ? (_openBlock(), _createElementBlock("svg", _hoisted_21, [...(_cache[10] || (_cache[10] = [_createElementVNode("path", {
          d: "M16 12V4h1V2H7v2h1v8l-2 2v2h5.2v6h1.6v-6H18v-2l-2-2z"
        }, null, -1)]))])) : _createCommentVNode("", true), _unref(chatStore).isConversationMuted(conv.id) ? (_openBlock(), _createElementBlock("svg", _hoisted_22, [...(_cache[11] || (_cache[11] = [_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M5.586 15H4a1 1 0 01-1-1v-4a1 1 0 011-1h1.586l4.707-4.707C10.923 3.663 12 4.109 12 5v14c0 .891-1.077 1.337-1.707.707L5.586 15z",
          "clip-rule": "evenodd"
        }, null, -1), _createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M17 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2"
        }, null, -1)]))])) : _createCommentVNode("", true), conv.type === 'internal' ? (_openBlock(), _createElementBlock("span", _hoisted_23, "内部")) : conv.type === 'customer' ? (_openBlock(), _createElementBlock("span", _hoisted_24, "客户")) : _createCommentVNode("", true)]), _createElementVNode("span", _hoisted_25, _toDisplayString(formatTime(conv.lastMessageTime)), 1)]), _createElementVNode("div", _hoisted_26, [_createElementVNode("p", _hoisted_27, _toDisplayString(conv.lastMessage), 1), conv.unreadCount > 0 ? (_openBlock(), _createElementBlock("span", {
          key: 0,
          class: _normalizeClass(["ml-2 flex h-[18px] min-w-[18px] flex-shrink-0 items-center justify-center rounded-full px-1 text-[10px] font-medium text-white", _unref(chatStore).isConversationMuted(conv.id) ? 'bg-slate-400' : 'bg-red-500'])
        }, _toDisplayString(conv.unreadCount > 99 ? '99+' : conv.unreadCount), 3)) : _createCommentVNode("", true)])])], 42, _hoisted_12);
      }), 128))]))]), (_openBlock(), _createBlock(_Teleport, {
        to: "body"
      }, [showConvMenu.value ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "fixed inset-0 z-[100]",
        onClick: _cache[2] || (_cache[2] = $event => showConvMenu.value = false),
        onContextmenu: _cache[3] || (_cache[3] = _withModifiers($event => showConvMenu.value = false, ["prevent"]))
      }, [_createElementVNode("div", {
        class: "absolute z-[101] min-w-[140px] rounded-lg border border-slate-200 bg-white py-1 shadow-lg",
        style: _normalizeStyle({
          left: convMenuPos.value.x + 'px',
          top: convMenuPos.value.y + 'px'
        })
      }, [_createElementVNode("button", {
        class: "flex w-full cursor-pointer items-center gap-2 px-3 py-1.5 text-left text-sm text-slate-600 hover:bg-slate-50",
        onClick: handlePin
      }, [_cache[12] || (_cache[12] = _createElementVNode("svg", {
        class: "h-4 w-4 text-slate-400",
        fill: "currentColor",
        viewBox: "0 0 24 24"
      }, [_createElementVNode("path", {
        d: "M16 12V4h1V2H7v2h1v8l-2 2v2h5.2v6h1.6v-6H18v-2l-2-2z"
      })], -1)), _createTextVNode(" " + _toDisplayString(_unref(chatStore).isConversationPinned(activeConv.value?.id) ? '取消置顶' : '置顶'), 1)]), _createElementVNode("button", {
        class: "flex w-full cursor-pointer items-center gap-2 px-3 py-1.5 text-left text-sm text-slate-600 hover:bg-slate-50",
        onClick: handleMute
      }, [_cache[13] || (_cache[13] = _createElementVNode("svg", {
        class: "h-4 w-4 text-slate-400",
        fill: "none",
        stroke: "currentColor",
        viewBox: "0 0 24 24"
      }, [_createElementVNode("path", {
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": "2",
        d: "M5.586 15H4a1 1 0 01-1-1v-4a1 1 0 011-1h1.586l4.707-4.707C10.923 3.663 12 4.109 12 5v14c0 .891-1.077 1.337-1.707.707L5.586 15z"
      })], -1)), _createTextVNode(" " + _toDisplayString(_unref(chatStore).isConversationMuted(activeConv.value?.id) ? '取消免打扰' : '消息免打扰'), 1)]), _cache[15] || (_cache[15] = _createElementVNode("div", {
        class: "my-1 border-t border-slate-100"
      }, null, -1)), _createElementVNode("button", {
        class: "flex w-full cursor-pointer items-center gap-2 px-3 py-1.5 text-left text-sm text-red-500 hover:bg-red-50",
        onClick: handleDeleteConv
      }, [...(_cache[14] || (_cache[14] = [_createElementVNode("svg", {
        class: "h-4 w-4",
        fill: "none",
        stroke: "currentColor",
        viewBox: "0 0 24 24"
      }, [_createElementVNode("path", {
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": "2",
        d: "M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
      })], -1), _createTextVNode(" 删除会话 ", -1)]))])], 4)], 32)) : _createCommentVNode("", true)]))]);
    };
  }
};